import React, { useState, useCallback, useEffect, useMemo, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DataTable from './reuseableComponents/DataTable';
import { Row, Col } from 'antd';
import { getDivisions, getProjectManagers } from '../../redux/actions/user.action';

const Divisions = () => {
  const dispatch = useDispatch();
  const themeMode = useSelector((state) => state.layout.themeMode);
  const [loader, setLoader] = useState(true);
  const projectManagers = useSelector((state) => state.users.projectManagers);

  useEffect(() => {
    setLoader(false);

    if (projectManagers.length < 1) {
      setLoader(true);
      dispatch(getProjectManagers()).finally(() => {
        setLoader(false);
      });
    }
    localStorage.setItem('tab', 'project_managers');
  }, []);

  const getRows = useMemo(() => {
    return projectManagers?.map((el, i) => ({
      key: i,
      id: el.id,
      projectManager: el.name,
      project_manager_id: el.id,
      // division: el.ProjectManagerDivision ? el.ProjectManagerDivision.name : 'N/A',
      division_id: el.division_id,
      projects: el.Projects,
      slack_id: el.slack_id,
      slack_avatar: el.slack_avatar,
    }));
  }, [projectManagers]);

  return (
    <Fragment>
      <Row>
        <Col span={24}>
          <div className={themeMode === 'dark' ? 'dark-bg' : ''}>
            <DataTable getRows={getRows} loader={loader} fetchProjectManagers={false} />
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};
export default Divisions;
